<form (ngSubmit)="changePassword()" [formGroup]="form" appSelectFirstInput>
	<h1 mat-dialog-title>Change Password</h1>
	<mat-dialog-content>
		<mat-form-field fxLayout="column" fxLayoutAlign="center" fxLayoutGap="15px">
			<mat-label>{{'changePasswordView.currentPasswordLabel' | translate}}</mat-label>
			<input [type]="showCurrentPassword ? 'text' : 'password'" formControlName="currentPassword" matInput
				   required/>
			<mat-error>{{'changePasswordView.currentPasswordLabel' | translate}} is required</mat-error>
			<button [matTooltip]="showCurrentPassword ? 'Hide Password' : 'Show Password'" color="primary"
					mat-icon-button matSuffix matTooltipPosition="left" type="button">
				<mat-icon (click)="toggleShowCurrentPassword()">
					{{showCurrentPassword ? 'visibility' : 'visibility_off'}}
				</mat-icon>
			</button>
		</mat-form-field>
		<mat-form-field fxLayout="column" fxLayoutAlign="center" fxLayoutGap="15px">
			<mat-label>{{'changePasswordView.newPasswordLabel' | translate}}</mat-label>
			<input [type]="showNewPassword ? 'text' : 'password'"
				   appValidateEqual="verifyPassword" formControlName="newPassword"
				   matInput required
				   reverse="true"/>
				<mat-error *ngIf="form.get('newPassword')?.errors?.minlength; else checkMaxLength">
					{{'changePasswordView.minLengthErrorText' | translate}}
				</mat-error>
				<ng-template #checkMaxLength>
					<mat-error *ngIf="form.get('newPassword')?.errors?.maxlength; else passwordRequired">
						{{'changePasswordView.maxLengthErrorText' | translate}}
					</mat-error>
				</ng-template>
				<ng-template #passwordRequired>
					<mat-error>{{'changePasswordView.passwordRequiredText' | translate}}</mat-error>
				</ng-template>
			<button [matTooltip]="showNewPassword ? 'Hide Password' : 'Show Password'" color="primary"
					mat-icon-button matSuffix matTooltipPosition="left" type="button">
				<mat-icon (click)="toggleShowNewPassword()">
					{{showNewPassword ? 'visibility' : 'visibility_off'}}
				</mat-icon>
			</button>
		</mat-form-field>
		<mat-form-field fxLayout="column" fxLayoutAlign="center" fxLayoutGap="15px">
			<mat-label>{{'changePasswordView.verifyPasswordLabel' | translate}}</mat-label>
			<input [type]="showVerifyPassword ? 'text' : 'password'" appValidateEqual="newPassword" formControlName="verifyPassword"
				   matInput
				   required reverse="false"/>
			<mat-error
					*ngIf="form?.get('verifyPassword')?.errors?.required">
				{{'changePasswordView.verifyPasswordLabel' | translate}} is required
			</mat-error>
			<mat-error
					*ngIf="form?.get('verifyPassword')?.errors?.doesNotMatch">
				{{'changePasswordView.passwordsDoNotMatchText' | translate}}
			</mat-error>
			<button [matTooltip]="showVerifyPassword ? 'Hide Password' : 'Show Password'" color="primary"
					mat-icon-button matSuffix matTooltipPosition="left" type="button">
				<mat-icon (click)="toggleShowVerifyPassword()" matSuffix>
					{{showVerifyPassword ? 'visibility' : 'visibility_off'}}
				</mat-icon>
			</button>
		</mat-form-field>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<div>
			<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
				<span>Cancel</span>
			</button>
		</div>
		<div>
			<button [color]="'primary'" mat-raised-button type="submit">
				<span>{{'changePasswordView.submitButton' | translate}}</span>
			</button>
		</div>
	</mat-dialog-actions>
</form>
